import Model, { attr } from "@ember-data/model";
import type ConsultationAllowedType from "./consultation/consultation-allowed-type";
import type ConsultationFrequency from "./consultation/consultation-frequency";
import type ConsultationReportType from "./consultation/consultation-report-type";

export default class ConfigurationConsultationModel extends Model {
  @attr("consultation-frequencies")
  declare consultationFrequencies: Array<ConsultationFrequency>;

  @attr("consultation-allowed-types")
  declare consultationAllowedTypes: Array<ConsultationAllowedType>;

  @attr("consultation-report-types")
  declare consultationReportTypes: Array<ConsultationReportType>;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "configuration-consultation": ConfigurationConsultationModel;
  }
}
